import { useHeader } from '@/layouts/MainLayout/HeaderContext'
import './Footer.scss'
import { CookieDialog } from '@/ux/Dialog/CookieDialog'

export function Footer() {
  const thisYear = new Date().getFullYear()
  const { privacyUrl } = useHeader()

  return (
    <div className="footer-wrapper" id="ui-footer">
      <span>
        &copy; {thisYear} PwC. PwC refers to the PwC network and/or one or more of its member firms, each of which is a
        separate legal entity. Please see{' '}
        <a href="https://www.pwc.com/structure" target="_blank" rel="noreferrer noopener">
          www.pwc.com/structure
        </a>{' '}
        for further details.
      </span>
      <div className="flex items-center">
        {privacyUrl && (
          <>
            <a href={privacyUrl} className="cursor-pointer" target="_blank" rel="noreferrer">
              Privacy
            </a>
            <div>{'|'}</div>
          </>
        )}
        <a href="https://www.pwc.co.za/en/about-us/legal-disclaimer.html" target="_blank" rel="noreferrer noopener">
          Legal
        </a>
        <div>{'|'}</div>
        <CookieDialog>
          <a className="cursor-pointer">Cookie Info</a>
        </CookieDialog>
      </div>
    </div>
  )
}
